import { IconButton, InputAdornment, TextField } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useState } from "react"
import { shippingInvoiceColNm } from "../../pages/ShippingProcess/constant"
import { generateMenuComboItem } from "utils"
import ComboBox from "components/ComboBox"
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime"
import { ArticleRounded } from "resource/muiImport"
import CheckboxFormControl from "components/CheckboxFormControl"
import { shpTypCombo } from "branch/pages/ShippingProcess/ShippingInvoiceDialogV2"
import { branchApiNm } from "../branchApiNm"
import ContainerVolDialog from "branch/pages/ShippingProcess/ContainerVolDialog"
import { groupJobOrderByContSizeFull } from "branch/pages/ShippingProcess/ShippingInvoiceDialogV2"
import CusComboWithAdd from "components/MasterComboWithAdd/CusComboWithAdd"
import JobComboWithAdd from "components/MasterComboWithAdd/JobComboWithAdd"
import POIComboWithAdd from "components/MasterComboWithAdd/POIComboWithAdd"
import { alertWarning } from "components/Alert"
import { shipmentApiNm } from "constants/shipmentConstant"


const ExportField = ({ dialogData, setDialogData }) => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dialogContainerVolOpen, setDialogContainerVolOpen] = useState(false)

  const textFieldProps = useCallback((name) => ({
    size: "small",
    sx: { width: 190 },
    label: shippingInvoiceColNm[name],
    value: dialogData[name] ?? "",
    onChange: (e) => setDialogData(o => ({ ...o, [name]: e.target.value })),
  }), [dialogData, setDialogData])

  const dateTimePickerProp = useCallback((name, required) => ({
    label: shippingInvoiceColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: dialogData[name],
    InputAdornmentProps: { style: { marginLeft: 0 } },
    // disableOpenPicker: disabled,
    // disabled: disabled,
    onChange: (newValue) => { setDialogData(o => ({ ...o, [name]: newValue })) },
    renderInput: (params) => <TextField
      size="small" {...params}
      sx={{ width: 190 }}
      required={required}
      error={required && !dialogData[name]} />,
  }), [dialogData, setDialogData])

  const generateJobNo = useCallback(() => {
    ax.post(branchApiNm.generateJobNo, dialogData).then(value => {
      if (value.data) {
        setDialogData(o => ({ ...o, JobNo: value.data }))
      }
    })
  }, [ax, dialogData, setDialogData])

  const generateCusRefNo = useCallback(() => {
    const postData = {
      ...dialogData,
      IsCusInv: true
    }
    ax.post(branchApiNm.generateJobNo, postData).then(value => {
      if (value.data) {
        setDialogData(o => ({ ...o, CusRefNo: value.data }))
      }
    })
  }, [ax, dialogData, setDialogData])



  const hanleOpenContainerVolDialog = useCallback(() => {
    setDialogContainerVolOpen(true)
  }, [])

  const handleJobOrderVolFinish = useCallback((jobOrders) => {
    const groupedArray = groupJobOrderByContSizeFull(jobOrders)

    console.log('Grouped job orders:', groupedArray);

    setDialogData(o => ({
      ...o,
      GroupJobOrders: jobOrders,
      Vol: groupedArray.map(item => `${item.count}x${item.text}`).join(", ")
    }))
  }, [setDialogData])
  return (
    <BoxFR sx={{ alignItems: "stretch" }}>
      <BoxFC sx={{ gap: 1 }}>
        <DateTimePickerCustomTime {...dateTimePickerProp("RecvDocDte", true)} />
        <DateTimePickerCustomTime {...dateTimePickerProp("BLRecvTm")} label="เวลารับ Booking" />
        <TextField {...textFieldProps("ShpmTypId")} required select>
          {generateMenuComboItem(msData.ShpmTypCombo.filter(item => [1, 4, 5, 6, 8, 9].includes(item.id)))}
        </TextField>
        <TextField {...textFieldProps("ShpTypId")} required select>
          {generateMenuComboItem(shpTypCombo)}
        </TextField>
        <CusComboWithAdd dialogData={dialogData} setDialogData={setDialogData} sx={{ width: 190 }} required={true} />
        <JobComboWithAdd dialogData={dialogData} setDialogData={setDialogData} sx={{ width: 190 }} required={true} />
        {/* <ComboBox sx={{ width: 190 }} options={cneeMemo} label={shippingInvoiceColNm.Cnee}
              selectedId={dialogData.CneeId}
              setSelectedId={(id) => setDialogData(o => ({ ...o, CneeId: id }))}
            /> */}
        <TextField {...textFieldProps("JobNo")} required={true} error={!dialogData.JobNo}
          onBlur={(e) => {
            ax.post(shipmentApiNm.getShipment, { ExactJobNo: e.target.value }, false).then(value => {
              if (value.data) {
                if (value.data.length > 0) {
                  alertWarning(`JobNo ${e.target.value} ซ้ำ`)
                }
              }
            })
          }}
        InputProps={{
          endAdornment: <InputAdornment position="end">
            <IconButton sx={{ p: 0 }} onClick={generateJobNo}>
              <AutoAwesomeIcon />
            </IconButton>
          </InputAdornment>
        }}
        />
        <TextField {...textFieldProps("Bkg")} />
        <TextField {...textFieldProps("CusRefNo")}
          InputProps={{
            endAdornment: <InputAdornment position="end">
              <IconButton sx={{ p: 0 }} onClick={generateCusRefNo}>
                <AutoAwesomeIcon />
              </IconButton>
            </InputAdornment>
          }} />
        <POIComboWithAdd dialogData={dialogData} setDialogData={setDialogData}
          sx={{ width: "100%" }} required={true} name="TakePOIId" />
        <POIComboWithAdd dialogData={dialogData} setDialogData={setDialogData}
          sx={{ width: "100%" }} required={true} name="LocPOIId" />
        <POIComboWithAdd dialogData={dialogData} setDialogData={setDialogData}
          sx={{ width: "100%" }} required={true} name="RtnPOIId" />
        {/* <DateTimePickerCustomTime {...dateTimePickerProp("ETA")} /> */}
        <TextField {...textFieldProps("Vol")}
          InputProps={{
            endAdornment: <InputAdornment position="end" sx={{ padding: 0, margin: 0 }}>
              <IconButton sx={{ p: 0 }} onClick={hanleOpenContainerVolDialog}>
                <ArticleRounded />
              </IconButton>
            </InputAdornment>
          }} />
      </BoxFC>
      <BoxFC sx={{ gap: 1 }}>
        <ComboBox sx={{ width: 190 }} options={msData.accountCombo} label={shippingInvoiceColNm.ManAccId}
          selectedId={dialogData.ManAccId}
          setSelectedId={(id) => setDialogData(o => ({ ...o, ManAccId: id }))}
        />
        <TextField {...textFieldProps("Agnt")} />
        <TextField {...textFieldProps("Vssl")} />
        <TextField {...textFieldProps("Voy")} />
        <TextField {...textFieldProps("Port")} />
        <TextField {...textFieldProps("IP_PoL")} />
        <TextField {...textFieldProps("Brnd")} />
        <TextField {...textFieldProps("EDNo")} />
        <TextField {...textFieldProps("CT")} />
        <TextField {...textFieldProps("KGM")} />
        <TextField {...textFieldProps("M3")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("ETD")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("ETA")} />
      </BoxFC>
      <BoxFC sx={{ gap: 1 }}>
        <DateTimePickerCustomTime {...dateTimePickerProp("RtnDteEn")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("TakeDteSt")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("RtnDteSt")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("FormTm")} />
        {/* <DateTimePickerCustomTime {...dateTimePickerProp("Doc1Tm")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("Doc2Tm")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("DocSndTm")} /> */}
        <DateTimePickerCustomTime {...dateTimePickerProp("ED0209CreTm")} />
        {/* <DateTimePickerCustomTime {...dateTimePickerProp("ED0409CreTm")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("CDCreTm")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("PayCstmTm")} />
        <DateTimePickerCustomTime {...dateTimePickerProp("FrtInvTm")} /> */}
        <DateTimePickerCustomTime {...dateTimePickerProp("FrtInvPaidTm")} />
      </BoxFC>
      <BoxFC sx={{ gap: 1 }}>
        <CheckboxFormControl label={shippingInvoiceColNm.IsOwnTuk} checked={dialogData.IsOwnTuk === 1}
          onChange={(e) => setDialogData(o => ({ ...o, IsOwnTuk: e.target.checked ? 1 : 0 }))} />
        <ComboBox sx={{ width: 190 }} options={msData.subContractCombo} label="จ้าง Shipping"
          selectedId={dialogData.ScId}
          setSelectedId={(id) => setDialogData(o => ({ ...o, ScId: id }))}
        />
        <TextField {...textFieldProps("Note")} multiline rows={10.5} />
        <TextField {...textFieldProps("Rmk")} multiline rows={10.5} />
        {/* <TextField {...textFieldProps("ContNoStr")} label="หมายเลขตู้" multiline rows={10} /> */}
      </BoxFC>

      <ContainerVolDialog
        dialogOpen={dialogContainerVolOpen}
        setDialogOpen={setDialogContainerVolOpen}
        initJobOrderData={dialogData.GroupJobOrders}
        onFinish={handleJobOrderVolFinish}
        mode="EX"
      />
    </BoxFR>
  )
}

export default ExportField